import "./Footer.css";
import logo from "../assets/Logo.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaYoutube,
} from "react-icons/fa";
import { FaLocationDot, FaWhatsapp } from "react-icons/fa6";

import { BearBlitz, LicknChew, Facebook, WhatsApp, Insatagram } from "../url";

import WhatsApp_Chat from "../assets/whatsapp.png";

const Footers = () => {
  return (
    <footer className="footers">
      <a href={WhatsApp} target="_blank" rel="noopener noreferrer">
        <img src={WhatsApp_Chat} className="whatsApp_Chat" />
      </a>
      <div className="footer-overlay">
        <div className="footer-top">
          <div className="footer-logo">
            <img src={logo} alt="Ponvel Exim" />
          </div>
          <div className="footer-links">
            <div>
              {/* <p>
                <a href={BearBlitz} target="_blank" rel="noopener noreferrer">
                  Bearbitz
                </a>
              </p>
              <p>
                <a href={LicknChew} target="_blank" rel="noopener noreferrer">
                  Lick n Chew
                </a>
              </p> */}
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Viska Coirs
                </a>
              </p>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  HAP DAY
                </a>
              </p>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Glossible
                </a>
              </p>
            </div>
            {/* <div>
              <p>
                <a href={BearBlitz} target="_blank" rel="noopener noreferrer">
                  Biscuits
                </a>
              </p>
              <p>
                <a href={BearBlitz} target="_blank" rel="noopener noreferrer">
                  Waffers
                </a>
              </p>
            </div>
            <div>
              <p>
                <a href={LicknChew} target="_blank" rel="noopener noreferrer">
                  Lollipops
                </a>
              </p>
              <p>
                <a href={LicknChew} target="_blank" rel="noopener noreferrer">
                  Candies
                </a>
              </p>
              <p>
                <a href={LicknChew} target="_blank" rel="noopener noreferrer">
                  Chocolates
                </a>
              </p>
            </div> */}
            <div>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Home care Products
                </a>
              </p>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Personal care Products
                </a>
              </p>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Coirs
                </a>
              </p>
              <p>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Home Textiles
                </a>
              </p>
            </div>
            <div>
              <div className="contact-infos">
                <a
                  href="tel:+918056390034"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaPhone style={{ transform: "scaleX(-1)" }} /> +91 8056390034
                </a>
              </div>
              <div className="contact-infos">
                <a
                  href="tel:+918925634323"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaPhone style={{ transform: "scaleX(-1)" }} /> +91 8925634323
                </a>
              </div>
              <div className="contact-infos">
                <a
                  href="https://wa.me/918248588257"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp /> +91 8248588257
                </a>
              </div>
              <div className="contact-infos">
                <a
                  href="https://wa.me/919487998245"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp /> +91 9487998245
                </a>
              </div>
              <div className="contact-infos">
                <a
                  href="https://wa.me/917200212245"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp /> +91 7200212245
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="contact">
            <FaEnvelope /> support@ponvelexim.com
          </div>
          <div className="social">
            <span>Follow Us On</span>
            <span>
              <a href={Facebook} target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href={WhatsApp} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
              <a href={Insatagram} target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </span>
          </div>
          <div className="copyright">© 2023 Ponvel Exim</div>

          <div className="address">
            <FaLocationDot /> 1/2, Ramasamy Gounder Layout, 60 Feet Road, <br />
            Perichipalayam South, Tirupur - 641 604.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footers;
